import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookies (jwt_token, session_token) carry auth; nothing stored client-side.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
